import { DefaultDateFormat } from "framework/utils/date/DefaultDateFormat";

export const getFormat = (from: Date, to: Date): "dd/MM" | "dd/MM/yyyy" => {
    from = new Date(from);
    to = new Date(to);
    return from.getFullYear() === to.getFullYear() && from.getFullYear() === new Date().getFullYear() ? 'dd/MM' : DefaultDateFormat;
}